import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DialogStateService {

  public dialogOpen: BehaviorSubject<any> = new BehaviorSubject<any>('');

  setDialogOpen(state: any) {
    console.log(state)
    this.dialogOpen = state;
  }

}
